<ng-container>
	<base-display [smallLetters]="" [bigLetters]="b()" [unit]="" [showScale]="false"></base-display>
</ng-container>